import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="notFoundWrapper">
      <Helmet>
        {/* <title>ایران رگالو | صفحه پیدا نشد!</title> */}
        <title>{Config.helmetTitle} | صفحه پیدا نشد!</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="space">
        <div className="text">
          <div className="align-middle">
            <h1>404</h1>
            <p>متاسفانه صفحه پیدا نشد!</p>
            <Link to="/" className="link">
              صفحه اصلی
            </Link>
          </div>
        </div>
        <div className="orbit-1"></div>
        <div className="moon-1 sm"></div>
        <div className="orbit-2"></div>
        <div className="moon-2 sm"></div>
        <div className="orbit-3"></div>
        <div className="moon-3"></div>
      </div>
    </div>
  );
};

export default React.memo(NotFound);
